import { createTheme, CssBaseline, ThemeProvider } from "@mui/material";
import "dayjs/locale/nl";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import Root from "./Root";
import NewTheme from "./theme/theme";
import { Theme } from "@emotion/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { nlNL } from "@mui/x-date-pickers/locales";
import "dayjs/locale/nl";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

declare module "@mui/material/styles" {
  interface Palette {
    light: Palette["primary"];
    dark: Palette["primary"];
  }

  interface PaletteOptions {
    light?: PaletteOptions["primary"];
    dark?: PaletteOptions["primary"];
  }
}

const theme = createTheme(NewTheme as Theme, nlNL);
const queryClient = new QueryClient();

root.render(
  <React.StrictMode>
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="nl">
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Root />
        </ThemeProvider>
      </QueryClientProvider>
    </LocalizationProvider>
  </React.StrictMode>
);
